<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销列表(详情)'}]"/>
        <div class="h-content">
            <div class="h-row ljjtablepaddings6">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            @selection-change="handleSelectionChange"
                            stripe
							border
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="45"
                                label="全选">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="id"
                                width="140"
                                :show-overflow-tooltip="true"
                                label="预测编码">
                        </el-table-column>
                        <el-table-column
                                prop="country"
                                :show-overflow-tooltip="true"
								width="90"
                                label="国家名称">
                            <template slot-scope="scope">
                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                :show-overflow-tooltip="true"
                                width="160"
                                label="型号">
									<template slot-scope="scope">
									    <div style="text-align: left;">
									        {{scope.row.proModel}}
									    </div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="产品编码">
                        </el-table-column>
                        <!--<el-table-column-->
                                <!--prop="protype"-->
                                <!--label="型号属性"-->
                                <!--width="90"-->
                                <!--:show-overflow-tooltip="true">-->
                        <!--</el-table-column>-->
                        <el-table-column
                                prop="proNumber"
                                :show-overflow-tooltip="true"
								width="60"
                                label="数量">
									<template slot-scope="scope">
									    <div style="text-align: right;">
									        {{scope.row.proNumber}}
									    </div>
									</template>
                        </el-table-column>
                        <!--<el-table-column-->
                                <!--prop="useInventory"-->
								<!--width="120"-->
                                <!--label="使用库存数量">-->
                            <!--<template slot-scope="scope">-->
                                <!--<el-input v-model="scope.row.useInventory" placeholder="库存数量" :disabled="u != 1" class="h-tableInput"-->
                                          <!--onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column v-if="u == 1 || cjcg == true" prop="useData" width="480" label="使用已预测库存">-->
                            <!--<template slot-scope="scope">-->
                                <!--<el-select style="width: 100%;" v-model="scope.row.useData" clearable placeholder="请选择" allow-create-->
                                           <!--class="h-tableInput" @change="addUseId(scope.row)" :multiple="true">-->
                                    <!--<el-option v-for="item in scope.row.uids" :key="item.code" :label="item.name"-->
                                               <!--:value="item.name">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column-->
                                <!--prop="useMeg"-->
                                <!--v-if="k == 1"-->
                                <!--width="480"-->
                                <!--label="使用已预测库存"-->
                                <!--:show-overflow-tooltip="true">-->
                            <!--<template slot-scope="scope">-->
                                <!--<div style="text-align: left;">-->
                                    <!--{{scope.row.useMeg}}-->
                                <!--</div>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column-->
                                <!--v-if="disabled"-->
                                <!--prop="isSpecific"-->
                                <!--width="110"-->
                                <!--:show-overflow-tooltip="true"-->
                                <!--label="是否需要排产">-->
                            <!--<template slot-scope="scope">-->
                                <!--<el-select style="width: 100%;" v-model="scope.row.isScheduling" clearable placeholder="请选择" allow-create :disabled="disabled1"-->
                                           <!--class="h-tableInput">-->
                                    <!--<el-option value="0" label="否"></el-option>-->
                                    <!--<el-option value="1" label="是"></el-option>-->
                                <!--</el-select>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column-->
                                <!--prop="isSpecific"-->
                                <!--width="110"-->
                                <!--:show-overflow-tooltip="true"-->
                                <!--label="常规或定制">-->
                            <!--<template slot-scope="scope">-->
                                <!--<dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column-->
                                <!--prop="specificReq"-->
                                <!--:show-overflow-tooltip="true"-->
								<!--min-width="130"-->
                                <!--label="改制大类">-->
									<!--<template slot-scope="scope">-->
									    <!--<div style="text-align: left;">-->
									        <!--{{scope.row.specificReq}}-->
									    <!--</div>-->
									<!--</template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column-->
                                <!--prop="specificReform"-->
                                <!--:show-overflow-tooltip="true"-->
                                <!--min-width="130"-->
                                <!--label="改制要求">-->
                            <!--<template slot-scope="scope">-->
                                <!--<div style="text-align: left;">-->
                                    <!--{{scope.row.specificReform}}-->
                                <!--</div>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column prop="reformPriceRmb" width="150" label="单台加价(元)">-->
                            <!--<template slot-scope="scope">-->
                                <!--<el-input v-model="scope.row.reformPriceRmb"-->
                                          <!--placeholder="单台加价"-->
                                          <!--:disabled="jj != 1 || scope.row.isSpecific == 1"-->
                                          <!--class="h-tableInput"-->
                                          <!--@keyup.native='keyupEvent($event,input)'>-->
                                <!--</el-input>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
<!--                        <el-table-column prop="reformPriceUsd" width="150" label="定制加价-美元">-->
<!--                        </el-table-column>-->
<!--                        改制类型不需要设定了 创建预测的时候自动判断-->
<!--                        <el-table-column label="改制类型" v-if="u == 1" class="h-elformWrap-2" :show-overflow-tooltip="true">-->
<!--                            <template slot-scope="scope">-->
<!--                                <el-select v-model="scope.row.specificType" class="h-tableInput"-->
<!--                                           :disabled="scope.row.isSpecific == 1"-->
<!--                                           clearable-->
<!--                                           placeholder="请选择">-->
<!--                                    <el-option label="表内改制" value="1"></el-option>-->
<!--                                    <el-option label="表外改制" value="2"></el-option>-->
<!--                                </el-select>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
<!--                        工艺经理不需要审批了  因此不需要配置工艺经理审批人-->
<!--                        <el-table-column v-if="k == 1" prop="gyUser" width="130" label="选择工艺经理" :show-overflow-tooltip="true">-->
<!--                            <template slot-scope="scope">-->
<!--                                <el-select v-model="scope.row.gyUser" clearable placeholder="请选择"-->
<!--                                           class="h-tableInput" :show-overflow-tooltip="true">-->
<!--                                    <el-option v-for="item in gyData" :key="item.code" :label="item.name"-->
<!--                                               :value="item.code">-->
<!--                                    </el-option>-->
<!--                                </el-select>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
                        <!--<el-table-column-->
                                <!--label="改制单上传"-->
                                <!--width="130"-->
                                <!--v-if="k == 1 || y == 1">-->
                            <!--<template slot-scope="scope">-->
                                <!--<brupload-->
                                        <!--:refid="scope.row.id"-->
                                        <!--reftype="改制单上传"-->
                                        <!--:showtime="false"-->
                                        <!--:uploadflag="k == 1 && scope.row.isSpecific == 2"-->
                                        <!--:delflag="k == 1">-->
                                <!--</brupload>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <!--<el-table-column-->
                                <!--v-if="k == 1 || y == 1"-->
                                <!--width="140"-->
                                <!--label="专用号">-->
                            <!--<template slot-scope="scope">-->
                                <!--<el-input v-model="scope.row.zycode" placeholder="专用号" :disabled="k != 1" class="h-tableInput"></el-input>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <el-table-column
                                prop="remark"
                                :show-overflow-tooltip="true"
                                label="备注">
								<template slot-scope="scope">
								    <div style="text-align: left;">
								        {{scope.row.remark}}
								    </div>
								</template>
                        </el-table-column>
                        <!--<el-table-column-->
                                <!--prop="cdate"-->
                                <!--:show-overflow-tooltip="true"-->
                                <!--value-format="yyyy-MM-dd"-->
                                <!--width="110"-->
                                <!--label="创建日期">-->
                        <!--</el-table-column>-->
                        <el-table-column
                                prop="deliveryDate"
                                :show-overflow-tooltip="true"
                                value-format="yyyy-MM-dd"
								width="110"
                                label="预计交货期">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <br>
            <div class="h-table h-mrt30 h-rowBox" v-if="showText" style="margin-top: 0.2rem;">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1">审批意见</h1>
                    <el-form :model="formLabelAlign" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine">
                        <el-form-item label="审批意见" class="h-elformWrap-2 " :required="true"
                                      style="margin:30px 0 40px 29px">
                            <el-input v-model="shenhetext" placeholder="请输入"
                                      class="zidaoO"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="apprButton">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="returnTable">返回</el-button>
				<el-button v-if="showrefuse" class="h-btn h-bBtn h-bgred" @click="auditFail">驳回</el-button>
				<el-button v-if="showpass" class="h-btn h-bBtn h-bggreen" @click="auditPass('form1')">通过</el-button>
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="findDetail">查看审批详情</el-button>
                
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        <!--地址信息-->
        <areaSelect
                :visible.sync="showdizhiflag"
                v-if="showdizhiflag"
                @choseObj="choseDizhi"
        />
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';
    import util from "../../../utils/util";
    import big from 'big.js';

    export default {
        data() {
            return {
                tableData: [],
                formLabelAlign:{},
                tableData3: [],
                options2: [],
                multipleSelection: [],
                gyData: [],
                shenhetext:'',
                instid: '',
                u: '',
                k: 2,
                y: '',
                jj: '',
                cjcg: false,
                showhistory: false,
                showrefuse: false,
                showpass: false,
                showText: false,
                showdizhiflag: false,
                moreCondition: false,
                options1: [{
                    code: '2',
                    name: '外部物流'
                }],
                rules: {
                    waybillType: [
                        {required: true, message: '请选择物流类型', trigger: 'change'}
                    ],
                    expectDate: [
                        {required: true, message: '请选择期货时间', trigger: 'change'},
                    ],
                    receiveUnit: [
                        {required: true, message: '请输入收货单位', trigger: 'blur'}
                    ],
                    receiver: [
                        {required: true, message: '请输入接收人', trigger: 'blur'}
                    ],
                    receverPhone: [
                        {required: true, message: '请输入接收人手机号', trigger: 'blur'},
                        {
                            pattern: /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/,
                            message: '请输入正确的手机号'
                        }
                    ],
                    detailAddress: [
                        {required: true, message: '请输入收货地址', trigger: 'blur'}
                    ],
                    cgGroupCode: [
                        {required: true, message: '请选择采购组', trigger: 'blur'}
                    ],
                    purchaseOrgCode: [
                        {required: true, message: '请选择采购组织', trigger: 'blur'}
                    ],
                },
                zy: {
                    numlist: null,
                    receiver: '',
                    receiveUnit: '生物医疗',
                    suserCode: '',
                    productCate: '',
                    type: '',
                    productNo: '',
                    waybillType: '',
                    unitPrice: '',
                    count: '',
                    totalPrice: '',
                    detailAddress: '青岛市城阳区华东路海尔生物医疗新兴产业园',
                    expectDate: '',
                    productCateName: '',
                    productDes: '',
                    suserName: '',
                    status: 0,
                    proId: '',
                    cgGroupCode: '',
                    province: '',
                    city: '',
                    country: '',
                    purchaseOrgCode:"",
                    ycId:''
                },
                table: {
                    data: [],
                    orderCg: [],
                    optflag: '',
                    yijianMsg: '',
                    aaa: '',
                    taskId: '',
                    instId: ''
                },
                q: {
                    id: '',
                    taskId: ''
                },
                multipleSelectioncopy:[],
                disabled:false,
                disabled1:false,
            }
        },
        mounted() {

        },
        created() {
            if (this.$route.query.taskstatus && this.$route.query.taskstatus == 1) {
                // TODO 跳转去查看页面也需要新加一个页面  因为拿到的是详情表的id  不再是主表id了
                this.$router.push({
                    path: "/yuce/showXiangqing",
                    query: {
                        cid: this.$route.query.ywid
                    }
                })
            }
            this.table.taskId = this.$route.query.taskid;
            this.table.instId = this.$route.query.instid;
            this.instid = this.$route.query.instid;
            if (this.$route.query.taskstatus == 0) {
                this.showrefuse = true;
                this.showpass = true;
                this.showText = true;
            }
            if (this.$store.getters.hasRole('swyl_waixiaogly')) {
                this.u = 1;
            }
            if (this.$store.getters.hasRole('swyl_wxcggly')) {
                // this.u = 1;
                this.cjcg = true;
            }
            if (this.$store.getters.hasRole('swyl_projl')) {
                this.k = 1;
            }
            if (this.$store.getters.hasRole('swyl_gzdshow')) {
                this.y = 1;
            }
            if (this.$store.getters.hasRole('swyl_cwrenyuan')) {
                this.jj = 1;
            }
            this.query();
            // this.selectGY();
        },
        methods: {
            //判断当前登录人是否是总部人员
            isGroup(){
                var form = {};
                form.spId = this.table.instId;
                ss.waixiao.isGroupMarket(form).then(rd => {
                    this.disabled = rd;
                    if(!rd){
                        for(var i=0;i<this.tableData.length;i++){
                            if(!this.tableData.isScheduling || this.tableData.isScheduling==null ||
                                this.tableData.isScheduling ==''){
                                this.disabled = false
                            }else {
                                this.disabled = true;
                                this.disabled1 = true;
                            }
                        }
                    }
                });
            },
            keyupEvent(e,input){
                e.target.value=e.target.value.replace(/[^\d.]/g, '');
                e.target.value=e.target.value.replace(/\.{2,}/g, '.');
                e.target.value=e.target.value.replace(/^\./g, '0.');
                e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));
                e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
                e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
                this.input=e.target.value
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                // if (this.moreCondition == true) {
                    this.tableData3 = [];
                    var vid = [];
                    for (var i = 0; i < this.multipleSelection.length; i++) {
                        vid.push(this.multipleSelection[i].id);
                    }
                    if (vid.length > 0) {
                        this.wxycload(vid);
                    }
                // }
            },
            chooseModify() {
                if (this.moreCondition) {
                    this.moreCondition = false;
                } else {
                    this.moreCondition = true;
                    // if (this.multipleSelection && this.multipleSelection.length > 0) {
                    //     this.tableData3 = [];
                    //     var vid = [];
                    //     for (var i = 0; i < this.multipleSelection.length; i++) {
                    //         vid.push(this.multipleSelection[i].id);
                    //     }
                    //     if (vid.length > 0) {
                    //         this.wxycload(vid);
                    //     }
                    // }
                }
            },
            //构造参数
            gouzaocanshu() {

                var entitylist = [];

                for (var c in this.tableData3) {

                    entitylist.push({

                        numlist: this.zy.numlist,
                        type: this.zy.type,
                        waybillType: this.zy.waybillType,
                        detailAddress: this.zy.detailAddress,
                        expectDate: this.zy.expectDate,
                        status: this.zy.status,
                        cgGroupCode: this.zy.cgGroupCode,
                        purchaseOrgCode: this.zy.purchaseOrgCode,
                        province: this.zy.province,
                        city: this.zy.city,
                        country: this.zy.country,
                        receiver: this.zy.receiver,
                        receverPhone: this.zy.receverPhone,
                        receiveUnit: this.zy.receiveUnit,


                        instid: this.instId || null,
                        cgId: this.tableData3[c].cgId || '',
                        zhubiaoid: this.tableData3[c].zhubiaoid || '',
                        productCateName: this.$getDictName("product_level",this.tableData3[c].productCate),
                        productDes: this.tableData3[c].productDes,
                        productCate: this.tableData3[c].productCate,
                        productNo: this.tableData3[c].productNo,
                        suserCode: this.tableData3[c].suserCode,
                        suserName: this.tableData3[c].suserName,
                        unitPrice: this.tableData3[c].unitPrice,
                        count: this.tableData3[c].Ycount,
                        proId: this.tableData3[c].proId,
                        // totalPrice:new big(this.tableData3[c].unitPrice).times(this.tableData3[c].Ycount),
                        totalPrice:new big(parseFloat(this.tableData3[c].unitPrice)).times(parseInt(this.tableData3[c].Ycount)),
                        //预测单号c
                        ycId: this.tableData3[c].Yid,
                        ycountry: this.tableData3[c].Ycountry,
                        ycuname: this.tableData3[c].Ycuname,
                        yremark: this.tableData3[c].Yremark,
                        yhgetdate: this.tableData3[c].Yhgetdate,
                    })
                    console.log("111111111111",entitylist)
                }

                return entitylist;

            },
            changeNum(v) {
                var total=0;
                for(var i=0;i<this.tableData3.length;i++){
                    var data = this.tableData3[i];
                    if(data.count && data.unitPrice){
                        total=new big(data.Ycount).times(data.unitPrice).plus(total);
                    }
                }
                this.zy.totalPrice = total;
            },
            choseDizhi(obj) {
                this.zy.detailAddress = obj.quobj.namepath;
                if (obj.zhenobj) {
                    this.zy.detailAddress = obj.zhenobj.namepath;
                }
                this.zy.detailAddress = this.zy.detailAddress + obj.addrdetail;
                this.zy.province = obj.shengobj.name;
                this.zy.city = obj.shiobj.name;
                this.zy.country = obj.quobj.name;
                this.showdizhiflag = false;
            },
            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },
            addUseId(v) {
                if (!v.useData || v.useData == '') {
                    v.zid = '';
                }
                v.useId = '';
                if (v.useData && v.useData.length != 0 && v.uids && v.uids.length != 0) {
                    for (var i = 0; i < v.useData.length; i++) {
                        for (var j = 0; j < v.uids.length; j++) {
                            if (v.useData[i] == v.uids[j].name) {
                                if (v.useId && v.useId != '') {
                                    v.useId = v.useId + v.uids[j].code + ","
                                } else {
                                    v.useId = v.uids[j].code + ","
                                }
                            }
                        }
                    }
                }
                if (v.zid && v.zid != '') {
                    v.useId = v.zid + v.useId;
                }
            },
            //查看审批流详情
            findDetail() {
                this.showhistory = true;
            },
            query() {
                this.q.id = this.$route.query.ywid;
                this.q.taskId = this.$route.query.taskid;
                // ss.waixiao.showSPList(this.q).then(rd => {
                ss.waixiao.showNewSPListPre(this.q).then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        rd[i]['useData'] = [];
                        rd[i]['uids'] = [];
                        rd[i]['zid'] = '';
                    }
                    this.tableData = rd;
                    for (var i = 0; i < this.tableData.length; i++) {
                        if (this.tableData[i].useMeg && this.tableData[i].useMeg != '') {
                            //循环设置
                            this.tableData[i].useData = _.split(this.tableData[i].useMeg || [], ",");
                        }
                        if (this.tableData[i].useId && this.tableData[i].useId != '') {
                            this.tableData[i].zid = this.tableData[i].useId;
                        }
                    }
                    var vid = [];
                    for (var i = 0; i < this.tableData.length; i++) {
                        this.selectStock(this.tableData[i]);
                        vid.push(this.tableData[i].id);
                    }
                    // this.wxycload(vid);
                })
            },
            selectStock(v) {
                var obj= {
                    proCode: v.proCode,
                    cucode: v.cucode
                }
                ss.waixiao.selectSPStock(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        for (var i = 0; i < rd.length; i++) {
                            v.uids.push({
                                code: rd[i].id,
                                name: rd[i].strDes,
                            });
                        }
                    }
                })
            },
            // selectGY(v) {
            //     ss.waixiao.selectGYuser().then(rd => {
            //         if (rd && rd.length > 0) {
            //             for (var i = 0; i < rd.length; i++) {
            //                 this.gyData.push({
            //                     code: rd[i].usercode,
            //                     name: rd[i].username,
            //                 });
            //             }
            //         }
            //     })
            // },
            wxycload(vd) {
                ss.waixiao.showDingdlist(vd).then(rd => {
                    if (rd && rd.length > 0) {
                        for (var i = 0; i < rd.length; i++) {
                            if (rd[i].protype!=null && rd[i].protype=="OEM"){
                                this.zy.receiver = rd[i].cuname;
                                var data = {
                                    "productCate":rd[i].cpdlName,
                                    "productNo":rd[i].proCode,
                                    "Ycount":rd[i].proNumber,
                                    "productOptions":[{id:rd[i].proCode,levelname:rd[i].proModel}],
                                    "Ycountry":rd[i].country,
                                    "Yid":rd[i].id,
                                    "Ycuname":rd[i].cuname,
                                    "Yremark":rd[i].remark,
                                    "Yhgetdate":rd[i].deliveryDate

                                };
                                this.changeSmail(data,1);
                                this.tableData3.push(data);
                            }
                        }
                    }
                })
            },
            changeSmail(v,flag) {
                v.unitPrice = '';
                this.zy.totalPrice = '';
                v.count = '';
                v.proId = '';
                //设置产品型号名称
                if (flag == 1) {
                    v.productOptions.forEach((item, index) => {
                        if (v.productNo == item.id) {
                            v.productDes = item.levelname;
                        }
                    })
                } else if (flag == 2) {
                    v.productOptions.forEach((item, index) => {
                        if (v.productDes == item.levelname) {
                            v.productNo = item.id;
                        }
                    })
                }

                // //暂时注释掉获取单价接口
                // var data = {mdmMaterialInfoPrice: {materialid: v, leltypecode: 3}}
                // ss.ProService.product2Detail(data).then(rd => {
                //     if (rd.obj && rd.obj.length > 0) {
                //         this.zy.unitPrice = rd.obj[0].mdmMaterialInfoPrice.value;
                //     } else {
                //         this.zy.unitPrice = '';
                //     }
                // })
                v.options2 = [];
                v.suserCode = '';
                v.suserName = '';
                this.vs = {};
                //获取供应商列表
                if (v.productNo) {
                    this.vs.productId = v.productNo;
                    ss.ProService.supplierByProductId(this.vs).then(rd => {
                        if (rd && rd.length > 0) {
                            //供应商信息
                            v.options2 = rd;
                            v.options2.forEach((item, index) => {
                                let canshu = {};
                                canshu.suserCode = item.finalSupplier;
                                canshu.productNo = v.productNo;
                                ss.orderCgService.selectProSupplier(canshu).then(rd => {
                                    console.log('我在这儿呀111', rd);
                                    //item.finalSupplierName = item.finalSupplierName + ',产品供应量占比: ' + rd.proportion;
                                })
                            })
                            console.log('我在这儿呀000', v.options2);

                            this.$set(v.options2, rd);
                        }
                    })
                }
            },
            //供应商名字
            changeSup(v) {
                var totalPrice = 0;
                v.options2.forEach((item, index) => {
                    if (v.suserCode == item.finalSupplier) {
                        v.suserName = item.finalSupplierName;
                        v.unitPrice = item.unitPrice;
                        v.proId = item.contractId;
                        this.tableData3.forEach((elements,index)=>{
                            console.log(elements.unitPrice,"////////");
                            console.log(elements.Ycount,"////////");
                            // if (totalPrice == 0) {
                            //     totalPrice = elements.unitPrice * elements.Ycount;
                                totalPrice = new big(parseFloat(elements.unitPrice)).times(parseInt(elements.Ycount)).plus(totalPrice);
                            // } else {
                            //     totalPrice = totalPrice + (elements.unitPrice * elements.Ycount);
                            // }
                        })
                    }
                })
                this.zy.totalPrice = totalPrice.toString();
            },
            auditPass(formName) {
                this.$msg.confirm("确认通过? 若没有勾选要审核的数据, 则会将所有预测全部通过！", () => {
                    var f = true;
                    if (f) {
                        this.table.aaa = 2
                        this.table.optflag = '审核通过';
                        this.table.yijianMsg = this.shenhetext;
                        if (this.multipleSelection && this.multipleSelection.length > 0) {
                            this.table.preData = this.multipleSelection;
                        } else {
                            this.table.preData = this.tableData;
                        }
                        if (this.moreCondition == true) {
                            this.zy.expectDate = util.riQi6(this.zy.expectDate)
                            this.zy.status = 0;
                            this.table.orderCg = this.gouzaocanshu();
                        } else {
                            this.table.orderCg = [];
                        }
                        ss.waixiao.auditCloseForecastPre(this.table).then(rd => {
                            if (rd.f == true) {
                                this.$msg.msgs(rd.msg);
                                this.shenhetext = '';
                                this.multipleSelection = [];
                                this.tableData3 = [];
                                //刷新右上角的代办个数
                                this.$store.dispatch("searchTasktotal")
                                //跳转回系统的代办列表
                                // this.$router.push({path:'/personal/dealCenter'})
                                // this.query();
                                this.newQw();
                            } else {
                                this.$msg.msge(rd.msg);
                                this.shenhetext = '';
                                this.newQw();
                            }
                        })
                    }
                })
            },
            auditFail() {
                this.$msg.confirm("确认驳回? 若没有勾选要审核的数据，则会将所有的预测全部驳回！", () => {
                    var reg = /^\s$/;
                    if (reg.test(this.shenhetext)) {
                        this.$msg.msge("审核意见不能为空!");
                        return;
                    }
                    if (this.shenhetext == "") {
                        this.$msg.msge("审核意见不能为空!");
                        return;
                    }
                    this.table.aaa = 1
                    this.table.optflag = '审核被驳回';
                    this.table.yijianMsg = this.shenhetext;
                    if (this.multipleSelection && this.multipleSelection.length > 0) {
                        this.table.preData = this.multipleSelection;
                    } else {
                        this.table.preData = this.tableData;
                    }
                    // ss.waixiao.shBTG(this.table).then(rd => {
                    ss.waixiao.auditCloseForecastPre(this.table).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                            this.shenhetext = '';
                            this.multipleSelection = [];
                            this.tableData3 = [];
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            //跳转回系统的代办列表
                            // this.$router.push({path:'/personal/dealCenter'})
                            this.newQw();
                        } else {
                            this.$msg.msge(rd.msg);
                            this.shenhetext = '';
                            this.newQw();
                        }
                    })
                })
            },
            newQw() {
                this.q.id = this.$route.query.ywid;
                this.q.taskId = this.$route.query.taskid;
                ss.waixiao.showNewSPList(this.q).then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        rd[i]['useData'] = [];
                        rd[i]['uids'] = [];
                        rd[i]['zid'] = '';
                    }
                    this.tableData = rd;
                    for (var i = 0; i < this.tableData.length; i++) {
                        if (this.tableData[i].useMeg && this.tableData[i].useMeg != '') {
                            //循环设置
                            this.tableData[i].useData = _.split(this.tableData[i].useMeg || [], ",");
                        }
                        if (this.tableData[i].useId && this.tableData[i].useId != '') {
                            this.tableData[i].zid = this.tableData[i].useId;
                        }
                    }
                    var vid = [];
                    for (var i = 0; i < this.tableData.length; i++) {
                        this.selectStock(this.tableData[i]);
                        vid.push(this.tableData[i].id);
                    }
                    this.tableData3 = [];
                    // this.wxycload(vid);
                    if (!this.tableData || this.tableData.length < 1) {
                        //跳转回系统的代办列表
                        this.$router.push({path:'/personal/dealCenter'})
                    }
                })
            },
            returnTable() {
                // this.$router.go(-1);
                this.$router.push({path: '/personal/dealCenter'})
            }
        }
    }
</script>
<style scoped>
    /*--------------- 审批样式 ----------------*/
    .h1{
        margin: 20px 0 0 31px;
    }
    .bbbb{
        background-color: white;
    }
    .apprButton {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
        padding: 0.3rem 0;
    }
    .cancel {
        width: 18%;
    }
    .pass {
        background-color: #006aca;
        color: white;
        width: 18%;
    }
    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }
    /*--------------- 审批样式 ------------------*/
</style>
<style>
	.wxshenhe .h-formbLine .h-elformWrap-2{
		width: 33.33%;
	}
	.wxshenhe .h-formbLine .el-form-item__label{
		width: 38%;
	}
	.wxshenhe .h-formbLine .el-form-item__content{
		width: 62%;
	}
	.ljjtablepaddings6 .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddings6 .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>